import { SharedFileRequest } from "@wingspanhq/wingspan-api-sdk";

import { RequirementAdditionalData } from "../types";

export const selectorIsSharedFileRequest = (
  data: RequirementAdditionalData
): data is SharedFileRequest => {
  return !!data && "contextType" in data;
};
